// extracted by mini-css-extract-plugin
export default {"container":"GooglePayTitle_container__Afs75","googlepayIcon":"GooglePayTitle_googlepayIcon__2T96H"};